<h1 mat-dialog-title>{{ title }}</h1>

<div mat-dialog-content>
  <form [formGroup]="formBid" autocomplete="off" class="bid-form">

    <!-- Estimated Cost -->
    <mat-form-field appearance="outline" class="full">
      <mat-label>Estimated cost</mat-label>

      <span matPrefix>
        <mat-icon fontIcon="attach_money" class="money-icon"></mat-icon>
      </span>

      <input
        matInput
        type="number"
        min="1"
        required
        formControlName="estimatedCost"
        (change)="onEstimatedCostChangeEvent($event)" />

      @if (formBid.get('estimatedCost')?.hasError('required')) {
        <mat-error>Estimated cost is required.</mat-error>
      }

      @if (formBid.get('estimatedCost')?.hasError('min')) {
        <mat-error>Estimated cost must be greater than $1.00.</mat-error>
      }
    </mat-form-field>

    @if (
      data.firstOrSecond === '1stBid' &&
      data.estimatedCost > data.estimatemax &&
      data.multipleBidsRequired === true &&
      (data.isSelected === true || bidSelected === true)
    ) {
      <div class="hint">
        Estimated cost is greater than {{ data.estimatemax | currency:'USD':'symbol':'1.0-0' }}.<br />
        A second estimate is required.
      </div>
    }

    <!-- Contractor -->
    <div class="contractor-row">
      <mat-form-field appearance="outline" class="full">
        <mat-label>Contractor</mat-label>
        <input
          matInput
          readonly
          required
          formControlName="AttachmentName"
          placeholder="Contractor name" />
      </mat-form-field>

      @if (data.firstOrSecond === '2ndBidEdit') {
        <button
          mat-flat-button
          color="accent"
          type="button"
          class="contractor-change"
          (click)="onClickChangeContractor()">
          Change
        </button>
      }
    </div>

    <!-- Hidden file input -->
    <input
      #ebbFileInput
      type="file"
      hidden
      (click)="ebbFileInput.value = null"
      (change)="ebbFileInputChange($event)" />

    <!-- Upload buttons -->
    <div class="upload-actions">
      <button
        mat-flat-button
        color="accent"
        type="button"
        (click)="ebbFileInput.click()">
        {{ fileUploadLabel }}
      </button>

      @if (showRotateImage) {
        <button
          mat-flat-button
          color="accent"
          type="button"
          (click)="rotateImageOrientation()">
          <mat-icon>rotate_right</mat-icon>
          Rotate {{ rotateDegree }}&deg;
        </button>
      }
    </div>

    <!-- File status -->
    <div class="file-status">
      @if (!fileError) {
        <p class="mat-body-2">{{ displayFileName }}</p>
      } @else {
        <p class="mat-error">
          <mat-icon inline>warning</mat-icon>
          {{ displayFileName }}
        </p>
      }
    </div>

    <!-- Helper / Preview -->
    <div class="preview-area">
      @if (!displayFileUrl) {
        <div class="helper-text">
          <p>Only the following file types can be uploaded:</p>
          <ul>
            @if (!data.isImage) {
              <li>Adobe PDF</li>
              <li>Microsoft Word DOCX</li>
            }
            <li>Image JPG</li>
            <li>Image PNG</li>
          </ul>
          <p>The maximum file size is {{ fileMaxSize }}MB.</p>
        </div>
      } @else {
        <div class="preview-box">
          @if (!data.isImage) {
            <img [src]="displayFileUrl" alt="uploaded file" class="preview-img" />
          }

          @if (displayLink === 'true') {
            <a class="file-link" href="" (click)="onViewFileEvent(fileId, payloadName); $event.preventDefault()">
              {{ payloadName }}
            </a>
          }
        </div>
      }
    </div>

    <!-- Hire Contractor -->
    <div class="hire-row">
      <mat-checkbox
        formControlName="selectThisBid"
        (change)="onClickSelect()">
        Hire Contractor
      </mat-checkbox>
    </div>

    @if (higherBidSelected === true) {
    <mat-form-field appearance="outline" class="full">
      <mat-label>Reason for selecting higher estimate</mat-label>
      <input matInput required aria-label="Reason for selecting higher estimate" id="reasonForHigherBid"
        formControlName="reasonForHigherBid" (change)="onReasonChangeEvent($event)" />
    
      @if (formBid.get('reasonForHigherBid')?.hasError('required')) {
      <mat-error>Reason is required.</mat-error>
      }
      @if (formBid.get('reasonForHigherBid')?.hasError('pattern')) {
      <mat-error>
        Please enter a valid reason.
      </mat-error>
      }
    </mat-form-field>
    }

  </form>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button type="button" (click)="onClickCancel()">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [mat-dialog-close]="data"
    [disabled]="formBid.invalid || disableSubmitBid">
    Save
  </button>
</div>
